import { render, staticRenderFns } from "./message-center.vue?vue&type=template&id=42928cd6"
import script from "./message-center.ts?vue&type=script&lang=ts&external"
export * from "./message-center.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports